import React, { useState } from 'react';

interface AgeCalculatorProps {
  onClose: () => void;
}

const AgeCalculator: React.FC<AgeCalculatorProps> = ({ onClose }) => {
  const [birthday, setBirthday] = useState<string>('');
  const [selectedTime, setSelectedTime] = useState<number>(0);
  const [displayBirthday, setDisplayBirthday] = useState<string>('');
  const [displayAge, setDisplayAge] = useState<number>(0);
  const [displayTime, setDisplayTime] = useState<string>('Days');

  const timeMeasurements = [
    { value: 0, displayName: 'Days' },
    { value: 1, displayName: 'Hours' },
    { value: 2, displayName: 'Minutes' }
  ];

  const calculateAge = () => {
    if (!birthday) return;
    
    const currentTime = new Date();
    const birthDate = new Date(birthday);
    const difference = currentTime.getTime() - birthDate.getTime();

    const daysAge = Math.floor(difference / 86400000);
    const hoursAge = Math.floor(daysAge * 24);
    const minsAge = Math.round(hoursAge * 60);

    const dateOptions: Intl.DateTimeFormatOptions = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    setDisplayBirthday(birthDate.toLocaleString('us-US', dateOptions));

    selectTimeMeasurement(selectedTime, daysAge, hoursAge, minsAge);
  };

  const selectTimeMeasurement = (timeValue: number, daysAge: number, hoursAge: number, minsAge: number): void => {
    setSelectedTime(timeValue);
    setDisplayTime(timeMeasurements[timeValue].displayName);

    switch (timeValue) {
      case 0:
        setDisplayAge(daysAge);
        break;
      case 1:
        setDisplayAge(hoursAge);
        break;
      case 2:
        setDisplayAge(minsAge);
        break;
      default:
        setDisplayAge(daysAge);
        break;
    }
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const timeValue = parseInt(e.target.value);
    if (birthday) {
      const currentTime = new Date();
      const birthDate = new Date(birthday);
      const difference = currentTime.getTime() - birthDate.getTime();

      const daysAge = Math.floor(difference / 86400000);
      const hoursAge = Math.floor(daysAge * 24);
      const minsAge = Math.round(hoursAge * 60);

      selectTimeMeasurement(timeValue, daysAge, hoursAge, minsAge);
    }
  };

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="birthday" className="form-label">Select your birthday:</label>
        <input
          type="date"
          className="form-control"
          id="birthday"
          value={birthday}
          onChange={(e) => setBirthday(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="timeMeasurement" className="form-label">Time measurement:</label>
        <select
          className="form-select"
          id="timeMeasurement"
          value={selectedTime}
          onChange={handleTimeChange}
        >
          {timeMeasurements.map((measurement) => (
            <option key={measurement.value} value={measurement.value}>
              {measurement.displayName}
            </option>
          ))}
        </select>
      </div>

      <button className="btn btn-primary" onClick={calculateAge}>
        Calculate Age
      </button>

      {displayBirthday && (
        <div className="mt-4">
          <div className="alert alert-info">
            <h5>Results:</h5>
            <p><strong>Birthday:</strong> {displayBirthday}</p>
            <p><strong>Age:</strong> {displayAge} {displayTime}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgeCalculator;
